import { Attributes, Model, NeoModel, Rules, Validation } from '@singularsystems/neo-core';

@NeoModel
export default class IssuerInvestmentAccrualScheduleReportCriteria extends Model.CriteriaBase {

    @Rules.Required()
    @Attributes.Nullable()
    public issuerInvestmentId: number | null = null;

    // Client only properties / methods

    @Attributes.NoTracking()
    public issuerInvestmentName: string = "";

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Issuer Client Schedule Report Criteria";
    }
}